import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PreAula } from 'src/app/models/pre-aula';
import { AulaVisualizacao } from 'src/app/models/aula-visualizacao';
import * as moment from 'moment';
import { QuestaoFlashCard } from 'src/app/models/questao-flash-card';
import { Opcao } from 'src/app/models/opcao';
import { AvaliacaoAula } from 'src/app/models/avaliacao-aula';

@Injectable({
  providedIn: 'root',
})
export class AulaService {
  constructor(private http: HttpClient) { }

  getAulasCronograma(id: number, data: any) {
    data = moment(data).locale('pt-br').format('YYYY-MM-DD');
    return this.http.get<any[]>(`${environment.baseApiUrl}/aulas/${id}/cronogramas?data=${data}`);
  }

  getPreAula(id: number) {
    return this.http.get<PreAula>(`${environment.baseApiUrl}/aulas/pre-aula/${id}`);
  }

  getAulaVisualizacao(id: number) {
    return this.http.post<AulaVisualizacao>(`${environment.baseApiUrl}/aulas/${id}/visualizacao`, {});
  }

  getAulas(modulo: number) {
    return this.http.get<Opcao[]>(`${environment.baseApiUrl}/aulas?modulo=${modulo}`);
  }

  getQuestoesFlashCard(id: number) {
    return this.http.get<QuestaoFlashCard[]>(`${environment.baseApiUrl}/aulas/${id}/flashcard`);
  }

  getAvaliacao(id: number) {
    return this.http.get<AvaliacaoAula>(`${environment.baseApiUrl}/aulas/${id}/avaliacoes`);
  }

  salvarAvaliacao(id: number, avaliacaoAula: AvaliacaoAula) {
    return this.http.post<AvaliacaoAula>(`${environment.baseApiUrl}/aulas/${id}/avaliacoes`, avaliacaoAula);
  }
}
